button {
    border: none;
    background: none;
    padding: 8px;

    &:hover {
        cursor: pointer;
        border: none;
    }
}

.wishlist-icon {
    filter: invert(73%) sepia(87%) saturate(5813%) hue-rotate(328deg) brightness(98%) contrast(87%);
}
